module.exports = __webpack_public_path__ + "img/33_57.060dbcb7.png";